import { useState, useCallback, useMemo } from 'react';
import { AlertItemCheckBoxType } from '../../../types';
import { modelIconAlert } from '../../../constants';

export interface UseAlertFiltersReturn {
    listCheckBox: AlertItemCheckBoxType[];
    allChecked: boolean;
    setListCheckBox: (filters: AlertItemCheckBoxType[]) => void;
    handleAllCheckboxChange: () => void;
    handleAlertTypeFilterChanged: (layerId: string, isChecked: boolean) => void;
    handleExclusiveSelection: (layerId: string) => void;
    resetFilters: () => void;
    updateAvailableTypes: (availableTypes: string[]) => void;
}

export default function useAlertFilters(): UseAlertFiltersReturn {
    const [listCheckBox, setListCheckBox] = useState<AlertItemCheckBoxType[]>(modelIconAlert);
    const [availableTypes, setAvailableTypes] = useState<string[]>([]);

    // Calculer allChecked - maintenant sur tous les types, pas seulement disponibles
    const allChecked = useMemo(() => {
        return listCheckBox.length > 0 && listCheckBox.every((item: AlertItemCheckBoxType) => item.isShow);
    }, [listCheckBox]);

    // Mettre à jour les types disponibles (pour feedback visuel uniquement)
    const updateAvailableTypes = useCallback((types: string[]) => {
        setAvailableTypes(types);
    }, []);

    // SUPPRIMÉ : Le useEffect qui réinitialisait automatiquement les checkboxes

    // Handle individual filter toggle - interaction libre pour tous les types
    const handleAlertTypeFilterChanged = useCallback((layerId: string, isChecked: boolean) => {
        const updatedListCheckBoxAlert = listCheckBox.map((item: AlertItemCheckBoxType) => {
            if (item.id === layerId) {
                return {
                    ...item,
                    isShow: isChecked,
                };
            }
            return item;
        });
        
        setListCheckBox(updatedListCheckBoxAlert);
    }, [listCheckBox]);

    // Handle exclusive selection - interaction libre pour tous les types
    const handleExclusiveSelection = useCallback((layerId: string) => {
        const updatedListCheckBoxAlert = listCheckBox.map((item: AlertItemCheckBoxType) => ({
            ...item,
            isShow: item.id === layerId,
        }));
        
        setListCheckBox(updatedListCheckBoxAlert);
    }, [listCheckBox]);

    // Handle "all" checkbox - active tous les types
    const handleAllCheckboxChange = useCallback(() => {
        // Only allow checking all filters when at least one is unchecked
        if (allChecked) {
            return; // Don't allow to uncheck all filters
        }
        
        const updatedListCheckBoxAlert = listCheckBox.map((item: AlertItemCheckBoxType) => ({
            ...item,
            isShow: true,
        }));
        
        setListCheckBox(updatedListCheckBoxAlert);
    }, [allChecked, listCheckBox]);

    const resetFilters = useCallback(() => {
        const resetFilters = modelIconAlert.map((item: AlertItemCheckBoxType) => ({
            ...item,
            isShow: true, // Par défaut, tout est coché
        }));
        setListCheckBox(resetFilters);
    }, []);

    return {
        listCheckBox,
        allChecked,
        setListCheckBox,
        handleAllCheckboxChange,
        handleAlertTypeFilterChanged,
        handleExclusiveSelection,
        resetFilters,
        updateAvailableTypes,
    };
} 